export interface ScheduleRoute {
    id: number;
    name: string;
    account_doc_id: string;
    assigned_user_id: string;
    folder_doc_id: string;
    created: string;
    last_modified: string;
    user_created: string;
    user_modified: string;
}

export interface SchedulesRoutes {
    rows: ScheduleRoute[];
    total: number;
}

export interface EntitySchedulesRoutesTab {
    status: boolean,
    data: SchedulesRoutes
}

export interface RouteFrequency {
    name: string;
    value: string;
    allow_days: boolean;
    summary: string;
    selectable_days: number[];
    auto_select?: boolean;
}

export interface PCNList {
    id: string;
    value: string;
    account_doc_id: string;
    folder_doc_id: string;
    folder_name: string;
    shift_label: string;
    marker_count: number;
    shift_label_id: number;
    session_type_id?: number;
    session_type_name?: string;
    frequencies?: RouteFrequency[];
    session_type_default_assignment_type?: string;
    email?: string;
    start_time?: string;
    end_time?: string | null;
}

export interface PCNRoutes {
    rows: PCNList[];
    total: number;
}

export interface PCNFiltersParameters {
    value?: string;
    folder_id?: string;
    folder_name?: string;
    filter_assign?: string;
    start_date?: string;
    end_date?: string;
    secondary_id_row_id?: string;
    session_type_id?: string;
}

export interface PCNAssignmentUser {
    secondary_id: string;
    user_id: string;
    start_time: string;
    end_time: string;
    email?: string;
    timestamp?: string;
}

export interface PCNMarkerCoords {
    id: string;
    name: string;
    coordinates: string;
}

export interface EntityPCN {
    pcnId: string;
    pcnValue: string;
    shiftLabel: string;
    sessionType?: string;
    frequencies?: RouteFrequency[];
    defaultFrequency?: string;
}

export interface RouteGridItem {
    marker_doc_id: string;
    module_group_doc_id: string;
}

export interface RouteGridList {
    [key: string]: RouteGridItem[];
}

export interface ShiftLabelParameters {
    id: number;
    name: string;
    start_time: string;
    end_time: string;
}

export interface SessionTypeParameters {
    id: number;
    name: string;
    priority: number;
    inclusion_type: string;
    deleted: number;
    module_group_doc_ids: string[];
    team_doc_ids: string[];
    frequencies: RouteFrequency[];
    shift_labels: ShiftLabelParameters[];
}

export class SchedulesRoutesTab {
    static create (routesData: EntitySchedulesRoutesTab): SchedulesRoutesTab {
        const {
            status,
            data: routes
        } = routesData;
        
        return new SchedulesRoutesTab(
            status,
            routes
        );
    }
    constructor(
        public readonly status: boolean,
        public readonly routes: SchedulesRoutes
    ) {}
}
